<template>
  <div class="vKeyboard-container" v-if="showOrHide">
    <div class="pickup-tickets-wrapper vkey-wrapper">
      <!-- <button class="closeBtnKeyboard" v-on:click="callClose()">&times;</button> -->
      <div class="virtual-keyboard-component">
        <div class="inputBoxKeyboardWrap" v-if="!hideTypingInput">
          <b-form-input type="text" class="inputBoxKeyboard-input" :value="inputValue" disabled placeholder="Enter Something...."></b-form-input>
        </div>
        <Keyboard
          :input="inputValue"
          @onChange="onChangeInput"
          :inputName="inputName"
          @onKeyPress="onKeyPress"
          :keyBoardType="keyType"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import SimpleKeyboard from "@/components/UIElements/SimpleKeyboard";
// import { mapState, mapGetters, mapActions } from "vuex";
import { generateRandomCode } from "@/helper/collection";

export default {
  components: {
    Keyboard: SimpleKeyboard,
  },
  props: {
    onClickHandler: { type: Function },
    onChangeEvent: { type: Function },
    onKeyEnter: { type: Function },
    showOrHide: { type: Boolean, default: true },
    hideTypingInput: { type: Boolean, default: false },
    inputName: { type: String },
    initialValue: { type: String, default: "" },
    keyBoardType: { type: String, default: "Default" },
  },
  data() {
    return {
      ShowVirtualKeyBoard: false,
      InputString: "",
      selectedEle: null,
    };
  },
  computed: {
    keyType() {
      return this.keyBoardType;
    },
    inputValue() {
      return this.initialValue || '';
    },
  },
  beforeMount() {},
  methods: {
    generateRandomCode,
    onKeyPress(button) {
      console.log(button);
      if (button == "{enter}") {
        this.$emit("onKeyEnter", button);
      }
      if (button == "{close}") {
        this.$emit("onClickClose");
      }
      this.$emit("onPressKey", button);
    },
    onChangeInput(event) {
      this.InputString = event;
      this.$emit("changeKeyboardInput", this.InputString);
      this.$emit("onChangeEvent", this.InputString);
    },
    callClose: function () {
      this.$emit("onClickClose");
    },
  },
};
</script>
<style>
.virtual-keyboard-component {
  width: 100%;
  height: auto;
  margin: auto;
}

.closeBtnKeyboard {
  width: 45px;
  border: none;
  height: 35px;
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: 0;
  font-size: 50px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  background-color: transparent;
  top: 4px !important;
  right: 4px !important;
  color: #6d6767;
  justify-content: center;
}

.vkey-wrapper {
  border-radius: 15px 15px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.inputBoxKeyboardWrap {
  width: 100%!important;
  display: flex!important;
  align-items: center!important;
  justify-content: center!important;
}

.inputBoxKeyboard-input {
  width: 85% !important;
  text-align: center!important;
  height: 40px!important;
  border: 1px solid black!important;
  background: transparent!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/Vkeyboard.vue